@if (selectionService.isEmpty()) {
    <ng-container *ngTemplateOutlet="emptyMessage()"></ng-container>
} @else {
    <div class="flex flex-column md:flex-row align-items-center">
        <ng-container
            *ngTemplateOutlet="
                selectedPatientTmpl;
                context: {
                    $implicit: selectionService.parentPatient(),
                    header: 'Original - Profile to Keep'
                }
            ">
        </ng-container>

        <div class="flex flex-row md:flex-column flex-order-2 md:flex-order-0 m-1 pt-0 md:pt-3 gap-2">
            <input type="hidden" />
            <button
                pButton
                type="button"
                label="Merge"
                class="m-button-primary"
                size="small"
                [disabled]="!selectionService.validSelection()"
                (click)="mergePatients()">
                <i class="material-icons">merge_type</i>
            </button>

            @if (clearSelection() && swapSelection()) {
                <div class="flex align-items-center justify-content-evenly gap-2">
                    <p-button
                        pTooltip="Clear"
                        tooltipPosition="bottom"
                        icon="pi pi-eraser"
                        severity="danger"
                        (onClick)="selectionService.clearSelection()" />

                    <p-button
                        pTooltip="Swap"
                        tooltipPosition="bottom"
                        icon="pi pi-arrow-right-arrow-left"
                        severity="secondary"
                        [disabled]="!selectionService.validSelection()"
                        (onClick)="selectionService.swapSelection()" />
                </div>
            } @else if (clearSelection()) {
                <p-button label="Clear" icon="pi pi-eraser" severity="danger" size="small" (onClick)="selectionService.clearSelection()" />
            } @else if (swapSelection()) {
                <p-button
                    label="Swap"
                    icon="pi pi-arrow-right-arrow-left"
                    severity="secondary"
                    size="small"
                    [disabled]="!selectionService.validSelection()"
                    (onClick)="selectionService.swapSelection()" />
            }
        </div>

        @if (selectionService.childPatient()) {
            <ng-container
                *ngTemplateOutlet="
                    selectedPatientTmpl;
                    context: {
                        $implicit: selectionService.childPatient(),
                        header: 'Duplicate - Profile to Delete'
                    }
                ">
            </ng-container>
        } @else if (selectChildMessage()) {
            <div class="flex-none md:flex-1 w-12 md:w-auto text-center">
                <ng-container *ngTemplateOutlet="selectChildMessage()"></ng-container>
            </div>
        }
    </div>
}

<ng-template #selectedPatientTmpl let-patient let-header="header">
    <div class="flex-none md:flex-1 w-12 md:w-auto">
        @if (patient) {
            <p-fieldset [legend]="header" class="w-12">
                <div class="flex flex-column">
                    <span class="text-2xl text-black-alpha-80">{{ patient.firstName }} {{ patient.lastName }}</span>
                    <div class="flex flex-wrap flex-1 align-items-center text-sm font-bold text-black-alpha-70">
                        @if (patient.miProNumber) {
                            <span class="mr-2">
                                <i class="pi pi-user text-xs mr-1"></i>
                                {{ patient.miProNumber }}
                            </span>
                        }

                        @if (patient.email) {
                            <span class="mr-2">
                                <i class="pi pi-at text-xs mr-1"></i>
                                {{ patient.email }}
                            </span>
                        }

                        @if (patient.phoneNumber) {
                            <span>
                                <i class="pi pi-phone text-xs"></i>
                                {{ patient.phoneNumber }}
                            </span>
                        }
                    </div>
                </div>
            </p-fieldset>
        }
    </div>
</ng-template>
